import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import type FormCCOtp from "@/interface/FormCCOtp";
import CCOnboardFormService from "@/service/restfulService/CCOnboardFormService";
import checkBiometricFlag from "./checkBiometricFlag";

export default function bioCardSubmit(
  ccFormValue: Ref<FormCC>,
  page0Overlay: Ref<boolean>,
  bioExist: Ref<boolean>,
  biometricVerification: Ref<string>,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  prop: any,
  resumeOtp: Ref<FormCCOtp>,
  otp: Ref<FormCCOtp>,
  creditLimit: Ref<string>,
  failedStatus: Ref<boolean>,
  cifErrorFlag: Ref<boolean>,
  jumpStep: (value: number, name: string, page: string) => void
): void {
  page0Overlay.value = true;

  // update card Id
  const cardSubmissionRequestModel = {
    webFormRequestId: ccFormValue.value.webFormRequestId,
    cardId: ccFormValue.value.selectedCard.cardId,
  };
  MasterService.cardSubmission(
    cardSubmissionRequestModel,
    ccFormValue.value.token
  )
    .then((res) => {
      if (res.status == 200) {
        // Finplus update card id
        if (prop.type == "FINPLUS") {
          jumpStep(4, "", "3");
        }
        // check gross salary change if already done pa rulescheck
        else if (ccFormValue.value.preAss.webFormRequestId != "") {
          const requestModel = {
            webFormRequestId: ccFormValue.value.webFormRequestId,
            preRequestId: ccFormValue.value.preAss.webFormRequestId,
            grossSalary: ccFormValue.value.basicInformation.grossSalary,
          };
          MasterService.preAssesmentValidate(
            requestModel,
            ccFormValue.value.token
          )
            .then((res) => {
              if (res.status == 200) {
                if (res.data.responseModel.check == "Exist") {
                  bioExist.value = true;
                } else {
                  bioExist.value = false;
                }
                const requestModel2 = {
                  // dropOffStep: "S0",
                  webFormRequestId: ccFormValue.value.webFormRequestId,
                  cardId: ccFormValue.value.selectedCard.cardId,
                  icNumber: ccFormValue.value.basicInformation.idNo,
                  webFormDetails: {
                    basicInformation: {
                      // title: ccFormValue.value.value.basicInformation.title,
                      fullName: ccFormValue.value.basicInformation.name,
                      idTypeCode: ccFormValue.value.basicInformation.idType,
                      idNo: ccFormValue.value.basicInformation.idNo,
                      oldIc:
                        ccFormValue.value.basicInformation.idType == "1"
                          ? ""
                          : ccFormValue.value.basicInformation.oldIc,
                      militaryNo:
                        ccFormValue.value.basicInformation.idType == "1"
                          ? ""
                          : ccFormValue.value.basicInformation.militaryNo,
                      nationalityCode:
                        ccFormValue.value.basicInformation.nationality,
                      dateOfBirth: ccFormValue.value.basicInformation.dob,
                      emailAddress: ccFormValue.value.basicInformation.email,
                      mobileCountryCode:
                        ccFormValue.value.basicInformation.countryCode,
                      mobileNumber: ccFormValue.value.basicInformation.mobileNo,
                      homePhoneCountryCode:
                        ccFormValue.value.basicInformation.homePhoneNo != ""
                          ? ccFormValue.value.basicInformation.homeCountryCode
                          : "",
                      homePhoneNumber:
                        ccFormValue.value.basicInformation.homePhoneNo,
                      grossMonthlySalary:
                        ccFormValue.value.basicInformation.grossSalary,
                      netMonthlySalary:
                        ccFormValue.value.basicInformation.netSalary,
                      professionCode:
                        ccFormValue.value.basicInformation.profession,
                      professionOthers:
                        ccFormValue.value.basicInformation.others,
                      anyLoan:
                        ccFormValue.value.basicInformation.question1 == "Yes"
                          ? true
                          : false,
                      repayment: ccFormValue.value.basicInformation.repayment,
                    },
                  },
                };

                MasterService.pageSubmit(requestModel2, ccFormValue.value.token)
                  .then((res) => {
                    if (res.status == 200) {
                      checkBiometricFlag(
                        ccFormValue,
                        prop,
                        biometricVerification,
                        otp,
                        bioExist,
                        page0Overlay,
                        creditLimit,
                        isTimeOut,
                        isSessionEnd,
                        failedStatus,
                        cifErrorFlag,
                        jumpStep
                      );
                    }
                  })
                  .catch((e) => {
                    if (e.response && e.response.data.code == "WB-401") {
                      // EndSession
                      isTimeOut.value = false;
                      isSessionEnd.value = true;
                    }
                    page0Overlay.value = false;
                    jumpStep(14, "denied2", "3");
                  });
              }
            })
            .catch((e) => {
              if (e.response && e.response.data.code == "WB-401") {
                // EndSession
                isTimeOut.value = false;
                isSessionEnd.value = true;
              }
              page0Overlay.value = false;
              jumpStep(14, "denied2", "3");
            });
        } else {
          const requestModel2 = {
            // dropOffStep: "S0",
            webFormRequestId: ccFormValue.value.webFormRequestId,
            cardId: prop.cardId,
            icNumber: ccFormValue.value.basicInformation.idNo,
            webFormDetails: {
              basicInformation: {
                // title: ccFormValue.value.value.basicInformation.title,
                fullName: ccFormValue.value.basicInformation.name,
                idTypeCode: ccFormValue.value.basicInformation.idType,
                idNo: ccFormValue.value.basicInformation.idNo,
                oldIc:
                  ccFormValue.value.basicInformation.idType == "1"
                    ? ""
                    : ccFormValue.value.basicInformation.oldIc,
                militaryNo:
                  ccFormValue.value.basicInformation.idType == "1"
                    ? ""
                    : ccFormValue.value.basicInformation.militaryNo,
                nationalityCode: ccFormValue.value.basicInformation.nationality,
                dateOfBirth: ccFormValue.value.basicInformation.dob,
                emailAddress: ccFormValue.value.basicInformation.email,
                mobileCountryCode:
                  ccFormValue.value.basicInformation.countryCode,
                mobileNumber: ccFormValue.value.basicInformation.mobileNo,
                homePhoneCountryCode:
                  ccFormValue.value.basicInformation.homePhoneNo != ""
                    ? ccFormValue.value.basicInformation.homeCountryCode
                    : "",
                homePhoneNumber: ccFormValue.value.basicInformation.homePhoneNo,
                grossMonthlySalary:
                  ccFormValue.value.basicInformation.grossSalary,
                netMonthlySalary: ccFormValue.value.basicInformation.netSalary,
                professionCode: ccFormValue.value.basicInformation.profession,
                professionOthers: ccFormValue.value.basicInformation.others,
                anyLoan:
                  ccFormValue.value.basicInformation.question1 == "Yes"
                    ? true
                    : false,
                repayment: ccFormValue.value.basicInformation.repayment,
              },
            },
          };

          MasterService.pageSubmit(requestModel2, ccFormValue.value.token)
            .then((res) => {
              if (res.status == 200) {
                ccFormValue.value.refNo = res.data.responseModel.refNo;
                if (
                  (prop.isAutoPopulate &&
                    resumeOtp.value.populateUpdatedFlag == "false") ||
                  (cifErrorFlag.value &&
                    resumeOtp.value.populateUpdatedFlag == "false")
                ) {
                  const requestModel2 = {
                    webFormRequestId: ccFormValue.value.webFormRequestId,
                    type: "CC_P",
                    otpType: "mobileOtp",
                  };
                  CCOnboardFormService.updateStatus(requestModel2, prop.token)
                    .then((res) => {
                      if (res.status == 200) {
                        const requestModel3 = {
                          webFormRequestId: ccFormValue.value.webFormRequestId,
                          type: "CC_P",
                          otpType: "emailOtp",
                        };
                        CCOnboardFormService.updateStatus(
                          requestModel3,
                          prop.token
                        )
                          .then((res) => {
                            if (res.status == 200) {
                              resumeOtp.value.populateUpdatedFlag == "true",
                                checkBiometricFlag(
                                  ccFormValue,
                                  prop,
                                  biometricVerification,
                                  otp,
                                  bioExist,
                                  page0Overlay,
                                  creditLimit,
                                  isTimeOut,
                                  isSessionEnd,
                                  failedStatus,
                                  cifErrorFlag,
                                  jumpStep
                                );
                            }
                          })
                          .catch((e) => {
                            if (
                              e.response &&
                              e.response.data.code == "WB-401"
                            ) {
                              // EndSession
                              isTimeOut.value = false;
                              isSessionEnd.value = true;
                            }
                            page0Overlay.value = false;
                          });
                      }
                    })
                    .catch((e) => {
                      if (e.response && e.response.data.code == "WB-401") {
                        // EndSession
                        isTimeOut.value = false;
                        isSessionEnd.value = true;
                      }
                      page0Overlay.value = false;
                    });
                } else
                  checkBiometricFlag(
                    ccFormValue,
                    prop,
                    biometricVerification,
                    otp,
                    bioExist,
                    page0Overlay,
                    creditLimit,
                    isTimeOut,
                    isSessionEnd,
                    failedStatus,
                    cifErrorFlag,
                    jumpStep
                  );
              }
            })
            .catch((e) => {
              if (e.response && e.response.data.code == "WB-401") {
                // EndSession
                isTimeOut.value = false;
                isSessionEnd.value = true;
              }
              page0Overlay.value = false;
              jumpStep(14, "denied2", "3");
            });
        }
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        isTimeOut.value = false;
        isSessionEnd.value = true;
      }
      page0Overlay.value = false;
      jumpStep(14, "denied2", "3");
    });
}
